document.addEventListener('DOMContentLoaded', function () {
  if (window.location.pathname.includes('/products/')) {
    const skuBreadcrumbElement = document.getElementById('breadcrumb-sku');

    function updateBreadcrumbSKU(newSKU) {
      if (skuBreadcrumbElement) {
        skuBreadcrumbElement.textContent = newSKU;
      }
    }

    function getSelectedVariant() {
      const selectedOptions = Array.from(document.querySelectorAll('select[name^="options"]')).map(
        (select) => select.value
      );

      return window.product.variants.find((variant) =>
        variant.options.every((option, index) => option === selectedOptions[index])
      );
    }

    function initializeVariantSelectListeners() {
      const variantSelects = document.querySelectorAll('select[name^="options"]');

      variantSelects.forEach((select) => {
        select.removeEventListener('change', onVariantChange);
        select.addEventListener('change', onVariantChange);
      });
    }

    function onVariantChange() {
      const selectedVariant = getSelectedVariant();
      if (selectedVariant) {
        updateBreadcrumbSKU(selectedVariant.sku);
      }
    }

    const observer = new MutationObserver(() => {
      initializeVariantSelectListeners();
    });

    observer.observe(document.body, { childList: true, subtree: true });

    initializeVariantSelectListeners();
  }
});
